// Marketplace API client + URL helpers.
// Talks to the new /api/listings, /api/search, /api/city endpoints.
import { TYPE_META, listingUrl, categoryUrl, visitCityUrl } from './seo';

const API = process.env.REACT_APP_BACKEND_URL;

const get = (path) => fetch(`${API}${path}`, { credentials: 'include' }).then((r) => {
  if (!r.ok) throw new Error(`API ${r.status}: ${path}`);
  return r.json();
});

const post = (path, body) => fetch(`${API}${path}`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  credentials: 'include',
  body: JSON.stringify(body),
}).then((r) => {
  if (!r.ok) return r.text().then((t) => { throw new Error(t || `API ${r.status}`); });
  return r.json();
});

const del = (path) => fetch(`${API}${path}`, { method: 'DELETE', credentials: 'include' }).then((r) => {
  if (!r.ok) throw new Error(`API ${r.status}: ${path}`);
  return r.json();
});

export const directory = {
  listings: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v !== undefined && v !== null && v !== '' && qs.set(k, v));
    return get(`/api/listings${qs.toString() ? `?${qs}` : ''}`);
  },
  types: () => get('/api/listings/types'),
  featuredBusinesses: (limit = 12) => get(`/api/featured-businesses?limit=${limit}`),
  trending: (filter = 'week', limit = 14) => get(`/api/trending?filter=${filter}&limit=${limit}`),
  listing: (slug) => get(`/api/listings/${encodeURIComponent(slug)}`),
  typedListing: (type, slug) => get(`/api/listings/${type}/${encodeURIComponent(slug)}`),
  search: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v !== undefined && v !== null && v !== '' && qs.set(k, v));
    return get(`/api/search${qs.toString() ? `?${qs}` : ''}`);
  },
  city: (city) => get(`/api/city/${encodeURIComponent(city)}`),

  // favorites
  addFavorite: (listing_id) => post('/api/favorites', { listing_id }),
  removeFavorite: (listing_id) => del(`/api/favorites/${encodeURIComponent(listing_id)}`),
  myFavorites: () => get('/api/favorites/me'),

  // reviews
  postReview: (payload) => post('/api/v2/reviews', payload),
  listReviews: (slug) => get(`/api/v2/reviews/${encodeURIComponent(slug)}`),

  // claim
  claim: (payload) => post('/api/v2/business/claim', payload),
};

export { TYPE_META, listingUrl, categoryUrl, visitCityUrl };
